import React from 'react';
import { Skeleton } from '@material-ui/lab';
import {Grid, makeStyles} from "@material-ui/core";

import Link from '../../../components/Link';
import { DetailsIcon } from '../../../images';
import { getFavoriteListType } from '../utils'
import {getModelPortfolioOwner, modelPortfolioAccessible} from '../../Modelportfolios/utils'
import {OwnerCell} from "../../Modelportfolios/components/InstrumentsList/table-data";
import {getTableOptionsActionName} from "../../../components/DashboardTable/utils";
import ComparisonButton from "../../CustomerDashboardV2/components_v2/ActionButtons/ComparisonButton";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "../../../images/DeleteIcon";
import WarningTooltip from "../../../components/WarningTooltip";



const NameCell = {
  header: "Favoritenlistename",
  body: {
    content: (item, options) => {

      if (options.loading) {
        return <Skeleton />
      }

      return item.name
    }
  },
  key: 'NameCell'
}

const TypeCell = {
  header: "Typ/Unternehmen",
  body: {
    content: (item, options) => {

      if (options.loading) {
        return <Skeleton />
      }

      return getFavoriteListType(item)
    }
  },
  key: 'TypeCell'
}

const InstrumentsCountCell = {
  header: {content: <>Anzahl Instrumente</>, justifyContent: 'center'},
  body: {
    content: (item, options) => {

      if (options.loading) {
        return <Skeleton />
      }

      return item.assets && item.assets.length;
    }
  },
  key: 'InstrumentsCountCell'
};

const useActionsStyles = makeStyles(() => ({
  actionButtonItem: {
    '& .MuiIconButton-root': {
      fontSize: '1em'
    }
  }
}));

const ActionsCell = {
  header: '',
  body: {
    content: (item, options) => {
      const classes = useActionsStyles();
      if (options.loading) {
        return <Skeleton />
      }

      const detailsTitle = getTableOptionsActionName(options, 'details');

      return (
        <Grid container style={{justifyContent: 'flex-start'}} spacing={1}>
          <Grid item className={classes.actionButtonItem}>
            {detailsTitle ? (
              <Link
                title={detailsTitle}
                onClick={() => options.onEdit(item)}
              />
            ) : (
              <WarningTooltip
                title={"Details"}
                icon={
                  <IconButton color={'primary'} onClick={() => options.onEdit(item)}>
                    <DetailsIcon />
                  </IconButton>
                }
              />
            )}
          </Grid>
          {options.onExtend && (
            <Grid item className={classes.actionButtonItem}>
             <ComparisonButton
                text="Vergleich öffnen"
                variant={"icon"}
                onButtonClick={() => options.onExtend(item)}
              />
            </Grid>
          )}
          { options.onDelete && modelPortfolioAccessible(item, options.auth) && (
            <Grid item className={classes.actionButtonItem}>
              <WarningTooltip
                title={"Löschen"}
                icon={
                  <IconButton color={'primary'} onClick={() => options.onDelete(item.id, item.name)}>
                    <DeleteIcon />
                  </IconButton>
                }
              />
            </Grid>
          )}
        </Grid>
      )
    }
  },
  key: 'ActionsCell'
}

export default {
  default: [{
    content: [NameCell],
    orderingFunction: (item) => (item.name || '').toLowerCase()
  }, {
    content: [TypeCell],
    orderingFunction: (item) => getFavoriteListType(item)
  }, {
    content: [OwnerCell],
    orderingFunction: (item) => getModelPortfolioOwner(item)
  }, {
    content: [InstrumentsCountCell],
    align: 'center',
    orderingFunction: (item) => item.assets && item.assets.length
  }, {
    content: [ActionsCell]
  }]
}